import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ children, className, ...props }) => (
  <div className={classnames('container', className)} data-testid="Container" {...props}>
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Container.defaultProps = {
  children: null,
  className: null,
};

export default Container;
